module.exports = __webpack_public_path__ + "img/finish.9345d161.gif";